import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { GroupTraining } from 'entities/group_training'
import { ReactNode, useMemo } from 'react'
import { Badge } from 'react-bootstrap'
import { Form } from 'utils/hooks'

export const groupTrainingLedgerColumnInfoList = (form?: Form<Record<string, unknown>>, type?: string): ColumnInfoList => {
    const values: ColumnInfo[] = [
        { width: 100, name: '実施日', th: true, form: form, orderAttr: 'group_training_ledger_date', searchType: { name: 'date', type: 'date' } },
        { width: 100, name: '講習会名', th: true, form: form, orderAttr: 'group_training_ledger_session_name', searchType: { name: 'sessionName', type: 'multiple_text' } },
        { width: 120, name: 'トレーナー', th: true, form: form },
        { width: 70, name: '受講状況', th: true, form: form, searchType: { name: 'completed', type: 'boolean' } },
        { name: 'URL', th: true, form: form },
    ]
    return {
        tableName: '',
        values: values,
    }
}

export type GroupTrainingLedgerTableDataProps = {
    groupTraining?: GroupTraining
    displaySetting: DisplaySetting
}

export const GroupTrainingLedgerTableData = (props: GroupTrainingLedgerTableDataProps): JSX.Element => {
    if (!props.groupTraining) {
        return (
            <>
                {props.displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (props.displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{props.groupTraining?.date}</TableCell>
                <TableCell>{props.groupTraining?.sessionName}</TableCell>
                <TableCell>{props.groupTraining?.trainer?.fullName}</TableCell>
                <TableCell>
                    <Badge bg={!props.groupTraining?.completed ? 'primary' : 'dark'}>
                        {props.groupTraining?.completed ? '受講済' : '未受講'}
                    </Badge>
                </TableCell>
                <TableCell>
                    <a
                        href={props.groupTraining?.url}
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        {props.groupTraining?.url}
                    </a>
                </TableCell>
            </>
        )
    }, [props.displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !props.displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
